import { useEffect, useState } from "react";
import { ShieldCheck, X } from "lucide-react";
import { AGE_GATE_BANNER, AGE_BANNER_STORAGE_KEY } from "@/lib/legal-copy";

export function AgeRuleBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!window.localStorage.getItem(AGE_BANNER_STORAGE_KEY)) {
        setShow(true);
      }
    } catch {
      /* ignore */
    }
  }, []);

  if (!show) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(AGE_BANNER_STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setShow(false);
  };

  return (
    <div className="mb-4 flex items-start gap-3 rounded-xl border border-primary/30 bg-primary/5 p-3 text-sm">
      <ShieldCheck className="mt-0.5 h-4 w-4 flex-none text-primary" />
      <p className="flex-1 text-foreground/90">{AGE_GATE_BANNER}</p>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-muted-foreground hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
